/**
 * @file HomePage.js
 * @description Manages the Home page content.
 * (REFACTORED: Stacked Monitor Layout + Equal Width Buttons)
 */

export class HomePage {
    constructor(services) { 
        this.contentManager = services.content;
        this.stateManager = services.state;
        this.eventBus = services.eventBus;

        this.dom = {
            content: document.querySelector('#home .content-block'),
        };
    }

    init() {
        this.render();
        this.addListeners();
    }

    render() {
        if (!this.dom.content) return;
        
        const bio = this.contentManager.getBio();
        const profile = this.contentManager.getProfile();
        const metadata = this.contentManager.getMetadata();
        
        // Natural Truncation
        const bioText = bio.paragraphs?.[0] || '';
        const elevatorPitch = bioText.includes('.') 
            ? bioText.split('.')[0] + '.' 
            : bioText.substring(0, 120) + '...';

        // 1. FILTER MONITOR ITEMS (Removed 'TIMEZONE')
        const monitorItems = this.contentManager.getCurrentFocus().filter(item => 
            ['FOCUS', 'ROLE'].includes(item.label)
        );

        // 2. BUILD MONITOR HTML (Stacked Layout + Cleaned Footer)
        const monitorHtml = `
            <div class="status-grid">
                ${monitorItems.map(item => `
                    <div class="inner-block monitor-block">
                        <span class="status-label">${item.label}</span>
                        <span class="status-value status-${item.style || 'normal'}">${item.value}</span>
                    </div>
                `).join('')}
            </div>
            
            <div class="inner-block system-footer-stacked">
                <span class="status-label">LAST_SYNC: <span class="status-value status-normal">${metadata.lastUpdated}</span></span>
            </div>
        `;

        // 3. ASSEMBLE PAGE
        // Changed "Download Resume" class to cta-primary for matching style
        this.dom.content.innerHTML = `
            <div class="section-wrapper">
                <h1 class="page-title">${profile.name}</h1>
                <h2 class="subsection-title">${profile.role}</h2>
                <p class="content-block-prose">${elevatorPitch}</p>
                
                <div class="cta-container" style="margin-top: 1.5rem; display: flex; gap: 1rem;">
                    <a href="#projects" class="cta-primary" data-section="projects" style="flex: 1;">View Projects</a>
                    <a href="${profile.resume_url}" class="cta-primary" target="_blank" style="flex: 1;">Download Resume</a>
                </div>
            </div>

            <div class="section-wrapper">
                <h2 class="page-title">System Monitor</h2>
                ${monitorHtml}
            </div>
        `;
    }

    addListeners() {
        const viewProjectsBtn = this.dom.content.querySelector('a[data-section="projects"]');
        if (viewProjectsBtn) {
            viewProjectsBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.stateManager.navigate(['projects']);
            });
        }
    }
}